(() => {
  const money = cents => new Intl.NumberFormat('en-IN', {style:'currency',currency:'INR',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
  const init = section => {
    if (section.dataset.bundleReady) return;
    section.dataset.bundleReady = 'true';
    const tabs = [...section.querySelectorAll('[data-bundle-tab]')];
    const panels = [...section.querySelectorAll('[data-bundle-panel]')];
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item, i) => {
          item.setAttribute('aria-selected', String(i === index));
          item.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
      });
      tab.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].click();
        tabs[next].focus();
      });
    });
    panels.forEach(panel => {
      const cards = [...panel.querySelectorAll('[data-bundle-product]')];
      let bundleBusy = false;
      let productsAdded = false;
      const button = panel.querySelector('[data-bundle-add]');
      const message = panel.querySelector('[data-bundle-message]');
      const code = panel.dataset.code.trim();
      const fixedSaving = code ? Math.max(0, Number(panel.dataset.discount) || 0) : 0;
      const bundlePrice = Math.max(0, Number(panel.dataset.bundlePrice) || 0);
      const selectedVariant = card => {
        const input = card.querySelector('[data-bundle-variant]');
        return input?.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      };
      const showVariantImage = (card, variant) => {
        const image = card.querySelector('.paw-bundles__main-image');
        if (!image || !variant?.dataset.image) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = variant.dataset.image;
        image.alt = variant.dataset.alt || image.alt;
        card.querySelectorAll('[data-bundle-thumb]').forEach(thumb => {
          const active = thumb.dataset.image === variant.dataset.image;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
      };
      const update = () => {
        let originalTotal = 0;
        const total = cards.reduce((sum, card) => {
          const variant = selectedVariant(card);
          const price = Number(variant?.dataset.price) || 0;
          originalTotal += Math.max(price, Number(variant?.dataset.mrp) || price);
          card.querySelector('[data-bundle-item-price]').textContent = money(price);
          return sum + price;
        }, 0);
        const dealPrice = code && bundlePrice > 0 && bundlePrice < total
          ? bundlePrice
          : total - Math.min(fixedSaving, total);
        const actualSaving = Math.max(0, originalTotal - dealPrice);
        const original = panel.querySelector('[data-bundle-total]');
        original.textContent = money(originalTotal);
        original.classList.toggle('is-struck', actualSaving > 0);
        panel.querySelector('[data-bundle-deal]').textContent = money(dealPrice);
        const row = panel.querySelector('[data-bundle-saving-row]');
        row.hidden = actualSaving <= 0;
        row.querySelector('[data-bundle-saving]').textContent = money(actualSaving);
        row.querySelector('[data-bundle-saving-percent]').textContent = originalTotal > 0 ? Math.round(actualSaving / originalTotal * 100) : 0;
        button.disabled = bundleBusy || (!productsAdded && (cards.length !== 3 || cards.some(card => !selectedVariant(card)?.value || selectedVariant(card).disabled)));
        button.querySelector('[data-bundle-add-label]').textContent = productsAdded ? panel.dataset.viewCartLabel : panel.dataset.addLabel;
      };
      panel.addEventListener('change', event => {
        if (!event.target.matches('[data-bundle-variant]')) return;
        const card = event.target.closest('[data-bundle-product]');
        const variant = selectedVariant(card);
        showVariantImage(card, variant);
        const optionLabel = card.querySelector('[data-bundle-selected-option]');
        if (optionLabel) optionLabel.textContent = variant.textContent.replace(' (Sold out)', '').trim();
        update();
      });
      panel.addEventListener('click', event => {
        const thumb = event.target.closest('[data-bundle-thumb]');
        if (!thumb) return;
        const card = thumb.closest('[data-bundle-product]');
        const select = card.querySelector('select[data-bundle-variant]');
        if (select && [...select.options].some(option => option.value === thumb.dataset.variantId && !option.disabled)) {
          select.value = thumb.dataset.variantId;
          select.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
      update();
      button.addEventListener('click', async () => {
        if (button.disabled) return;
        if (productsAdded) { window.location.assign(panel.dataset.cartUrl); return; }
        const items = cards.map(card => ({id:Number(selectedVariant(card).value),quantity:1}));
        bundleBusy = true;
        update();
        message.textContent = 'Adding your bundle…';
        try {
          await window.PawCart.mutate(async refresh => {
            productsAdded = true;
            const response = await fetch(panel.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
            if (!response.ok) {
              productsAdded = false;
              const error = await response.json();
              throw new Error(error.description || error.message || 'Could not add the bundle.');
            }
            if (code) {
              const discountResponse = await fetch(panel.dataset.updateUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code})});
              if (!discountResponse.ok) throw new Error(panel.dataset.discountUnconfirmed);
              const cart = await refresh();
              const allocations = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(entry => entry.discount_application))];
              const applicable = (cart.discount_codes || []).some(entry => entry.applicable === true && entry.code.toUpperCase() === code.toUpperCase()) || allocations.some(entry => entry?.type === 'discount_code' && entry.title.toUpperCase() === code.toUpperCase());
              if (!applicable) throw new Error(panel.dataset.discountUnconfirmed);
            } else {
              await refresh();
            }
          });
          window.location.assign(panel.dataset.cartUrl);
        } catch (error) {
          message.textContent = productsAdded ? panel.dataset.discountUnconfirmed : error.message || 'Could not add the bundle. Please try again.';
        } finally {
          bundleBusy = false;
          update();
        }
      });
    });
  };
  document.querySelectorAll('[data-paw-bundles]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-paw-bundles]').forEach(init));
})();




